import { render, staticRenderFns } from "./side-item.vue?vue&type=template&id=7982e34c&scoped=true"
import script from "./side-item.vue?vue&type=script&lang=js"
export * from "./side-item.vue?vue&type=script&lang=js"
import style0 from "./side-item.vue?vue&type=style&index=0&id=7982e34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982e34c",
  null
  
)

export default component.exports